import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { DomainService } from '../../services/domain/domain.service';

export const internalDomainGuard: CanMatchFn = () => {
  const domainService = inject(DomainService);
  const router = inject(Router);

  if (window.location.hostname === 'localhost') return true;

  if (!domainService.initialized) {
    console.warn('[Guard] DomainService não inicializado. Bloqueando acesso.');
    return router.parseUrl('/');
  }

  if (domainService.shouldRedirectToAdmin) {
    window.location.href = domainService.targetAdminUrl;
    return false;
  }
  if (domainService.isInternal) {
    return true;
  }

  return router.parseUrl('/');
};